import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

const Datenschutz = () => (
  <div className="min-h-screen bg-background">
    <div className="container max-w-2xl py-8">
      <Link to="/">
        <Button variant="ghost" size="sm" className="mb-6 gap-2">
          <ArrowLeft className="h-4 w-4" /> Zurück
        </Button>
      </Link>

      <h1 className="text-2xl font-bold text-foreground mb-2">Datenschutzerklärung</h1>
      <p className="text-sm text-muted-foreground mb-8">Stand: März 2026</p>

      <div className="space-y-8 text-sm leading-relaxed text-muted-foreground">
        <section>
          <h2 className="text-base font-semibold text-foreground mb-2">1. Verantwortlicher</h2>
          <p>
            Verantwortlich im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:<br /><br />
            Collabobit<br />
            Julia Weichner<br />
            Thomas-Jefferson-Str. 53<br />
            68309 Mannheim<br />
            E-Mail: info@collabobit.de
          </p>
        </section>

        <section>
          <h2 className="text-base font-semibold text-foreground mb-2">2. Übersicht der Verarbeitungen</h2>
          <p>Wir verarbeiten personenbezogene Daten nur, soweit dies zur Bereitstellung einer funktionsfähigen Plattform sowie unserer Inhalte und Leistungen erforderlich ist. Die Verarbeitung personenbezogener Daten erfolgt regelmäßig nur nach Einwilligung des Nutzers oder wenn die Verarbeitung durch gesetzliche Vorschriften gestattet ist.</p>
        </section>

        <section>
          <h2 className="text-base font-semibold text-foreground mb-2">3. Rechtsgrundlagen</h2>
          <p>Soweit wir für Verarbeitungsvorgänge personenbezogener Daten eine Einwilligung einholen, dient Art. 6 Abs. 1 lit. a DSGVO als Rechtsgrundlage.</p>
          <p className="mt-2">Bei der Verarbeitung personenbezogener Daten, die zur Erfüllung eines Vertrages erforderlich ist, dient Art. 6 Abs. 1 lit. b DSGVO als Rechtsgrundlage. Dies gilt auch für Verarbeitungsvorgänge, die zur Durchführung vorvertraglicher Maßnahmen erforderlich sind.</p>
          <p className="mt-2">Ist die Verarbeitung zur Wahrung eines berechtigten Interesses unseres Unternehmens erforderlich und überwiegen die Interessen, Grundrechte und Grundfreiheiten des Betroffenen nicht, dient Art. 6 Abs. 1 lit. f DSGVO als Rechtsgrundlage.</p>
        </section>

        <section>
          <h2 className="text-base font-semibold text-foreground mb-2">4. Erhobene Daten</h2>
          <h3 className="font-medium text-foreground mt-3 mb-1">4.1 Registrierung</h3>
          <p>Bei der Registrierung erheben wir: Name, E-Mail-Adresse, Telefonnummer (optional), Passwort (verschlüsselt). Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO.</p>

          <h3 className="font-medium text-foreground mt-3 mb-1">4.2 Host-Registrierung (Pre-Launch)</h3>
          <p>Zusätzlich erheben wir bei der Anmeldung als Host: Adresse des Ladepunkts, Angaben zur Wallbox (Steckertyp, Leistung), Fotos des Ladepunkts (optional), Verfügbarkeitszeiten. Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO.</p>

          <h3 className="font-medium text-foreground mt-3 mb-1">4.3 Fahrer-Warteliste</h3>
          <p>Für die Warteliste erheben wir: Name, E-Mail-Adresse, Standort, Angaben zur Ladesituation. Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung).</p>

          <h3 className="font-medium text-foreground mt-3 mb-1">4.4 Buchungsdaten</h3>
          <p>Bei Buchungen speichern wir: Buchungszeitraum, gewählter Ladepunkt, Zahlungsbetrag, Transaktions-ID. Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO.</p>

          <h3 className="font-medium text-foreground mt-3 mb-1">4.5 Standortdaten</h3>
          <p>Die Adressen von Ladepunkten werden als Geokoordinaten gespeichert, um die Kartensuche zu ermöglichen. Es erfolgt kein Echtzeit-Tracking von Nutzern. Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO.</p>
        </section>

        <section>
          <h2 className="text-base font-semibold text-foreground mb-2">5. Zahlungsabwicklung</h2>
          <p>Die Zahlungsabwicklung erfolgt über Stripe, Inc. (510 Townsend Street, San Francisco, CA 94103, USA). Bei der Zahlung werden Zahlungsdaten direkt an Stripe übermittelt. Wir selbst speichern keine Kreditkarten- oder Bankdaten.</p>
          <p className="mt-2">Datenschutzerklärung von Stripe: <a href="https://stripe.com/de/privacy" target="_blank" rel="noopener noreferrer" className="text-primary underline">https://stripe.com/de/privacy</a></p>
          <p className="mt-2">Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO.</p>
        </section>

        <section>
          <h2 className="text-base font-semibold text-foreground mb-2">6. Hosting und Infrastruktur</h2>
          <p>Unsere Plattform wird gehostet bei:</p>
          <p className="mt-2"><strong className="text-foreground">Supabase, Inc.</strong> — Datenbank und Authentifizierung<br />
          Standort der Server: EU (Frankfurt am Main, Deutschland)</p>
          <p className="mt-2"><strong className="text-foreground">Lovable / Netlify</strong> — Frontend-Hosting<br />
          Standort der Server: EU / USA</p>
          <p className="mt-2">Es bestehen ggf. Standardvertragsklauseln (SCC) gemäß Art. 46 Abs. 2 lit. c DSGVO für Datenübermittlungen in Drittländer.</p>
        </section>

        <section>
          <h2 className="text-base font-semibold text-foreground mb-2">7. Cookies und Tracking</h2>
          <p>Unsere Plattform verwendet ausschließlich technisch notwendige Cookies für die Sitzungsverwaltung und Authentifizierung. Wir setzen keine Tracking-, Werbe- oder Analyse-Cookies ein.</p>
          <p className="mt-2">Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der Bereitstellung der Plattform).</p>
        </section>

        <section>
          <h2 className="text-base font-semibold text-foreground mb-2">8. Newsletter</h2>
          <p>Wenn Sie sich für unseren Newsletter anmelden, speichern wir Ihre E-Mail-Adresse und optional Ihren Namen. Der Versand erfolgt nur nach ausdrücklicher Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Sie können sich jederzeit vom Newsletter abmelden.</p>
        </section>

        <section>
          <h2 className="text-base font-semibold text-foreground mb-2">9. Speicherdauer</h2>
          <p>Personenbezogene Daten werden gelöscht, sobald der Zweck der Speicherung entfällt. Für Vertragsdaten gelten die handels- und steuerrechtlichen Aufbewahrungsfristen (6 bzw. 10 Jahre gemäß §§ 147 AO, 257 HGB). Nutzerdaten werden bei Kontolöschung unverzüglich gelöscht, soweit keine gesetzlichen Aufbewahrungspflichten bestehen.</p>
        </section>

        <section>
          <h2 className="text-base font-semibold text-foreground mb-2">10. Ihre Rechte</h2>
          <p>Sie haben gegenüber uns folgende Rechte hinsichtlich Ihrer personenbezogenen Daten:</p>
          <ul className="mt-2 list-disc list-inside space-y-1">
            <li><strong className="text-foreground">Auskunft</strong> (Art. 15 DSGVO) — über die von uns verarbeiteten Daten</li>
            <li><strong className="text-foreground">Berichtigung</strong> (Art. 16 DSGVO) — unrichtiger Daten</li>
            <li><strong className="text-foreground">Löschung</strong> (Art. 17 DSGVO) — Ihrer gespeicherten Daten</li>
            <li><strong className="text-foreground">Einschränkung</strong> (Art. 18 DSGVO) — der Verarbeitung</li>
            <li><strong className="text-foreground">Datenübertragbarkeit</strong> (Art. 20 DSGVO) — in einem maschinenlesbaren Format</li>
            <li><strong className="text-foreground">Widerspruch</strong> (Art. 21 DSGVO) — gegen die Verarbeitung</li>
            <li><strong className="text-foreground">Widerruf</strong> — erteilter Einwilligungen mit Wirkung für die Zukunft</li>
          </ul>
          <p className="mt-3">Zur Ausübung Ihrer Rechte wenden Sie sich bitte an: info@collabobit.de</p>
        </section>

        <section>
          <h2 className="text-base font-semibold text-foreground mb-2">11. Beschwerderecht</h2>
          <p>Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die Verarbeitung Ihrer personenbezogenen Daten zu beschweren. Die für uns zuständige Aufsichtsbehörde ist:</p>
          <p className="mt-2">
            Der Landesbeauftragte für den Datenschutz und die Informationsfreiheit Baden-Württemberg<br />
            Lautenschlagerstraße 20<br />
            70173 Stuttgart<br />
            <a href="https://www.baden-wuerttemberg.datenschutz.de" target="_blank" rel="noopener noreferrer" className="text-primary underline">www.baden-wuerttemberg.datenschutz.de</a>
          </p>
        </section>

        <section>
          <h2 className="text-base font-semibold text-foreground mb-2">12. Änderungen</h2>
          <p>Wir behalten uns vor, diese Datenschutzerklärung zu aktualisieren, um sie an geänderte Rechtslagen oder Änderungen unserer Plattform anzupassen. Die aktuelle Version finden Sie stets auf dieser Seite.</p>
        </section>
      </div>
    </div>
  </div>
);

export default Datenschutz;
